import { RouteItemDef } from "./../../../types/app.types";

export const getPermissions = (
  path: string,
  routes: RouteItemDef[]
): string[] | null => {
  for (const item of routes) {
    if (item.path === path && item.permissions) {
      return item.permissions;
    }
    if (item.children) {
      const childPermissions = getPermissions(path, item.children);
      if (childPermissions) {
        return childPermissions;
      }
    }
  }
  return null;
};
